import { render } from "./MenuForm.vue?vue&type=template&id=2fca3a08&scoped=true"
import script from "./MenuForm.vue?vue&type=script&lang=js"
export * from "./MenuForm.vue?vue&type=script&lang=js"

import "./MenuForm.vue?vue&type=style&index=0&id=2fca3a08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fca3a08"]])

export default __exports__